import React, { useEffect, useRef } from "react";

function Paypal({ price, getPaypalDetail }) {
  const paypalRef = useRef();

  useEffect(() => {
    const renderPayPalButtons = () => {
      if (window.paypal && paypalRef.current) {
        paypalRef.current.innerHTML = "";

        window.paypal
          .Buttons({
            createOrder: (data, actions) => {
              return actions.order.create({
                intent: "CAPTURE",
                purchase_units: [
                  {
                    description: "License Fee",
                    amount: {
                      currency_code: "USD",
                      value: price,
                    },
                  },
                ],
              });
            },
            onApprove: async (data, actions) => {
              try {
                const order = await actions.order.capture();
                getPaypalDetail(order);
              } catch (error) {
                console.error("❌ Order capture failed:", error);
              }
            },
            onError: (err) => {
              console.error("PayPal Error:", err);
            },
          })
          .render(paypalRef.current);
      }
    };

    const addPayPalScript = () => {
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&disable-funding=credit,card&vault=true`;
      script.async = true;
      script.onload = renderPayPalButtons;
      document.body.appendChild(script);
    };

    if (window.paypal) {
      renderPayPalButtons();
    } else {
      if (!document.querySelector(`script[src*="paypal.com/sdk/js"]`)) {
        addPayPalScript();
      }
    }
  }, [price, getPaypalDetail]);

  return <div ref={paypalRef}></div>;
}

export default Paypal;
